/* tslint:disable */
/* eslint-disable */
/**
 * Scania Configurator
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { SummaryItem } from './SummaryItem'
import {
  SummaryItemFromJSON,
  SummaryItemFromJSONTyped,
  SummaryItemToJSON,
} from './SummaryItem'

/**
 *
 * @export
 * @interface ConfigChangeResultPackages
 */
export interface ConfigChangeResultPackages {
  /**
   *
   * @type {Array<SummaryItem>}
   * @memberof ConfigChangeResultPackages
   */
  items?: Array<SummaryItem> | null
}

/**
 * Check if a given object implements the ConfigChangeResultPackages interface.
 */
export function instanceOfConfigChangeResultPackages(value: object): boolean {
  let isInstance = true

  return isInstance
}

export function ConfigChangeResultPackagesFromJSON(
  json: any,
): ConfigChangeResultPackages {
  return ConfigChangeResultPackagesFromJSONTyped(json, false)
}

export function ConfigChangeResultPackagesFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ConfigChangeResultPackages {
  if (json === undefined || json === null) {
    return json
  }
  return {
    items: !exists(json, 'Items')
      ? undefined
      : json['Items'] === null
      ? null
      : (json['Items'] as Array<any>).map(SummaryItemFromJSON),
  }
}

export function ConfigChangeResultPackagesToJSON(
  value?: ConfigChangeResultPackages | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    Items:
      value.items === undefined
        ? undefined
        : value.items === null
        ? null
        : (value.items as Array<any>).map(SummaryItemToJSON),
  }
}
